import { useEffect } from "react";

/** Fixed-position success banner, so a "Saved" confirmation is visible
 *  regardless of scroll position -- several admin forms (Events, Articles,
 *  Locations, Award credit) are long enough that the old inline <p className="ok">
 *  above the form sat off-screen once you'd scrolled down to hit submit,
 *  giving no visible sign anything happened. Auto-dismisses after 4s, or on click. */
export default function Toast({ message, onDismiss }: { message: string; onDismiss: () => void }) {
  useEffect(() => {
    const t = setTimeout(onDismiss, 4000);
    return () => clearTimeout(t);
  }, [message, onDismiss]);

  return (
    <div className="toast toast-success" onClick={onDismiss} role="status">
      {message}
    </div>
  );
}
